import { LitElement, html } from '@hh/global.js'

class CountrySelectorPopup extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this._init()
  }

  _init() {
    if (!window.mdApp_openAndRefreshModal) return

    this.classList.add('block')
    this.classList.remove('hidden')
  }

  trapFocus(element) {
    // Get all focusable elements inside the modal
    const focusableElements = element.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    setTimeout(() => {
      // Set the focus to the first focusable element
      firstFocusableElement.classList.add('focus-visible');
      firstFocusableElement.focus();
    }, 100);

    function handleFocus(e) {
      // Check if tab or shift+tab is pressed
      const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) { // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          e.preventDefault();
          lastFocusableElement.focus(); // move to the last element
        }
      } else { // if tab key is pressed
        if (document.activeElement === lastFocusableElement) { // if focus is on the last focusable element
          e.preventDefault();
          firstFocusableElement.focus(); // move to the first element
        }
      }
    }

    // Listen for tab key presses
    element.addEventListener('keydown', handleFocus);
  }
  handleCustomSelectorClick(e) {
    const modal = document.getElementById('md-app-embed__modal');
    this.trapFocus(modal);

    window.mdApp_openAndRefreshModal()
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'shipping_country_modal_shown'
    })
  }

  render() {
    return html`<slot @click="${this.handleCustomSelectorClick}"></slot>`
  }
}

customElements.define('hh-country-selector', CountrySelectorPopup)
